import React, { FC, useState, useContext, useEffect } from 'react';
import { EventListingLogo, AvatarLogo } from '../SvgIcon';
import { Link } from 'gatsby';
import { UserContext } from '../../context/userContext';
import { useLocation, useMatch } from '@reach/router';
import { ResponsiveMenu, UserDropdown } from './ResponsiveMenu';
interface NavBarProps {
  title: string;
}

const NavBar: FC<NavBarProps> = ({ title }) => {
  const match = useMatch('webapp/live/:liveId');
  const location = useLocation();
  const isDemo = location.hostname === 'demo.coolstrummer.com';
  const { state, toggleFullScreen } = useContext(UserContext);
  useEffect(() => {
    if (match && match.path === 'webapp/live/:liveId') {
      if (!state.fullScreen) {
        toggleFullScreen();
      }
    } else if (state.fullScreen) {
      toggleFullScreen();
    }
  }, [match]);

  return (
    <>
      {state.fullScreen ? (
        <div className="navbar bg-transparent sticky top-0 z-50 -mb-16 items-top pt-0 justify-end pointer-events-none">
          <Link to="/" className="pointer-events-auto">
            <AvatarLogo />
          </Link>
          <div className="pointer-events-auto">
            <UserDropdown />
          </div>
        </div>
      ) : (
        <div className="navbar bg-base-100 sticky top-0 z-50 py-0">
          <div className="flex container mx-auto max-w-6xl justify-between items-center">
            <Link to="/">
              <div className="flex items-center">
                <EventListingLogo />
                <span className="ml-2 font-space-grotesk text-xl md:text-2xl font-black text-primary">
                  {isDemo ? 'Demo App' : title}
                </span>
              </div>
            </Link>
            <div className="flex-1"></div>
            <div className="flex gap-2">
              <ResponsiveMenu />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export { NavBar };
